module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Dw0TrP/tc-custom/cover.jpg?1684306037416?1693968918144",
      "alt": "This image is the cover for the book Haunted Stark County, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haunted Stark County, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Stroll along silent corridors of an abandoned asylum and linger among graves of Civil War dead - and discover the eerie ends of Stark County's departed souls.")])]), _c('br'), _c('p', [_vm._v("Ghostly diners, violent crimes of passion, phantoms peering from theatre balconies, canal workers who still walk the towpaths - the haunted history of Stark County includes characters and legends as bizarre as they are terrifying. Take a bone-chilling journey with Sherri Brake, owner of Haunted Heartland Tours, as she recounts tales of superstitious pioneers and the horrors of the great influenza epidemic of 1918. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sherri Brake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sherri Brake has been studying the paranormal and its accompanying history for twenty-six years. For the past five years she has led hundreds of tours as the owner of the award-winning Haunted Heartland Tours (www.HauntedHistory.net). She is very active in the local history community as a civil war re-enactor and as a Board Trustee for the Chippewa Rogues Hollow Historical Society in neighboring Wayne County, Ohio. Recently she has been featured on PBS' Stark County Alive (2004) and Lost in Ohio. She also lead a group in the Mansfield Reformatory for the Travel Channel's Americas Top 10 Scariest Places and has been a guest on various talk radio programs as an authority on ghosts and local legends.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Haunted America\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0